<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <CompanyTypeListing />
    </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import CompanyTypeListing from "@/views/pages/admin/companyType/companyTypeListing";

export default {
    page: {
        title: i18n.t("module.companyType"),
    },
    components: { Layout, PageHeader, CompanyTypeListing },
    data() {
        return {
            title: i18n.t("module.companyType"),
            items: [
                {
                    text: i18n.t("module.workplace"),
                    href: '/workplaces',
                },
                {
                    text: i18n.t("module.companyType"),
                    active: true,
                },
            ],
        };
    },
}
</script>